<template>
	<div
		ref="articleSwitch"
		aria-live="polite"
		:style="
			`position: relative; width: 100%; ${
				enterAnimation || leaveAnimation ? `height:${tempBodyHeight}px` : ''
			};`
		"
	>
		<transition
			:name="routeChangedByBrowser ? 'no-animation' : 'browser'"
			@after-leave="afterLeave"
			@after-enter="afterEnter"
		>
			<article-view
				ref="article1"
				v-if="toggle && !leaveAnimation"
				v-bind="propertiesArray[0]"
				:isCurrent="toggle"
				:key="1"
			></article-view>
		</transition>
		<transition
			:name="routeChangedByBrowser ? 'no-animation' : 'browser'"
			@after-leave="afterLeave"
			@after-enter="afterEnter"
		>
			<article-view
				ref="article2"
				v-if="!toggle && !leaveAnimation"
				v-bind="propertiesArray[1]"
				:isCurrent="!toggle"
				:key="2"
			></article-view>
		</transition>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { uiComponents } from '@/tools/viewState';
import { mapStateNested } from '@/tools/helpers';
import { mutationTypes, actionTypes, getterTypes } from '@/types';
import ArticleView from '@/components/ArticleView.vue';
import { whenTransitionEnds } from '@/tools/animationHelpers';

export default {
	data() {
		return {
			toggle: false,
			propertiesArray: [{}, {}],
			enterAnimation: false,
			leaveAnimation: false,
			tempBodyHeight: 0,
		};
	},
	components: {
		ArticleView,
	},
	computed: {
		...mapState(['routeChangedByBrowser']),
		...mapStateNested('swipe', ['articleProperties']),
		...mapStateNested('dataSourceCFG', ['exhibitionMap', 'configWebClient']),
		...mapGetters([getterTypes.historyCur, getterTypes.getScrolledArticlePosition]),
	},
	methods: {
		...mapMutations([mutationTypes.scrollSavePagePosition, mutationTypes.scrollSetDirection]),
		...mapActions([actionTypes.scrollSetWrapper]),
		afterLeave() {
			this.leaveAnimation = false;
			this.enterAnimation = true;
			// set body height to avoid no scrolling to stored position if new content not rendered yet

			this.tempBodyHeight =
				this.getScrolledArticlePosition({ ...this.articleProperties.current }) + window.screen.height;
			this.$nextTick(() => {
				window.scrollTo(0, this.getScrolledArticlePosition({ ...this.articleProperties.current }));
				requestAnimationFrame(() => {
					// set Scroll direction up after page change
					this.scrollSetDirection({ direction: 'up' });
				});
			});
		},
		afterEnter() {
			this.enterAnimation = false;
			this.tempBodyHeight = window.screen.height; // default temp Height
		},
	},

	watch: {
		articleProperties(newProperties, oldProperties) {
			// save last scroll position
			this.scrollSavePagePosition({ ...oldProperties.current, scroll: window.scrollY });
			if (newProperties.history) {
				this.tempBodyHeight = window.document.body.scrollHeight;
				this.leaveAnimation = true; // start fade out
			}
			this.toggle = !this.toggle;
			this.propertiesArray[this.toggle ? 0 : 1] = { ...newProperties.current };
		},
	},
	mounted() {
		this.scrollSetWrapper(window);
		window.history.scrollRestoration = 'manual'; //avoid browser  messing with restoring scroll position
	},
};
</script>
